import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { colors } from '../../config/styles/colors';
import { typography } from '../../config/styles/typography';
import SmartSearchCardsStyles from './SmartSearchCards.style';

const SmartSearchCards = ({ onSelectionChange, initialSelections = {}, smartSearchData = null }) => {
  const [selections, setSelections] = useState({
    location: initialSelections.location || null,
    surface: initialSelections.surface || null,
    finish: initialSelections.finish || null,
  });

  const getSmartSearchConfig = () => {
    if (smartSearchData?.questions) {
      return smartSearchData.questions;
    }

    return [];
  };

  const handleSelection = (category, value) => {
    const newSelections = {
      ...selections,
      [category]: selections[category] === value ? null : value,
    };
    setSelections(newSelections);

    if (onSelectionChange) {
      onSelectionChange(newSelections);
    }
  };

  const smartSearchConfig = getSmartSearchConfig();

  const renderOption = (category, option) => {
    const isSelected = selections[category] === option.id;

    const buttonStyle = isSelected
      ? {
          background: colors.sky['sky-01'],
          border: `1px solid ${colors.sky['sky-06']}`,
          borderRadius: '8px',
          padding: `6px ${typography.sm1}`,
          color: colors.black.shade1,
          opacity: 1,
        }
      : {
          border: `1px solid ${colors.gray.shade42}`,
          borderRadius: '8px',
          padding: `6px ${typography.sm1}`,
          opacity: 1,
        };

    return (
      <button
        key={option.id}
        type="button"
        className="smart-search-option"
        style={buttonStyle}
        onClick={() => handleSelection(category, option.id)}
      >
        <span className="option-label">{option.label}</span>
        {isSelected && <span className="remove-icon">×</span>}
      </button>
    );
  };

  return (
    <div className="smart-search-cards">
      {smartSearchConfig.map((questionConfig) => (
        <div key={questionConfig.id} className="smart-search-card">
          <h3 className="card-title">{questionConfig.question}</h3>
          <div className={`options-container ${questionConfig.id === 'surface' ? 'surface-options' : ''}`}>
            {questionConfig.options.map((option) => renderOption(questionConfig.id, option))}
          </div>
        </div>
      ))}

      <style jsx>{SmartSearchCardsStyles}</style>
    </div>
  );
};

SmartSearchCards.propTypes = {
  onSelectionChange: PropTypes.func,
  initialSelections: PropTypes.shape({
    location: PropTypes.string,
    surface: PropTypes.string,
    finish: PropTypes.string,
  }),
  smartSearchData: PropTypes.shape({
    questions: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        question: PropTypes.string.isRequired,
        options: PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
          })
        ).isRequired,
      })
    ),
  }),
};

SmartSearchCards.defaultProps = {
  onSelectionChange: null,
  initialSelections: {},
  smartSearchData: null,
};

export { SmartSearchCards };
